import _ from "lodash";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import { StyleTypeContext } from "../../../umbilical_tools";
import { InlineIcon } from "@iconify/react";
import jssVariables from "../../../jss_setup";

const safetyInfoStyles = createUseStyles({
  list: (props) => ({
    padding: [jssVariables.half_gap, 0],
    display: "grid",
    gridGap: jssVariables.normal_gap,
    ..._.get(props, "customStyles.list", {}),
  }),
  row: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content 1fr",
    gridGap: jssVariables.half_gap,
    alignItems: "start",
    textTransform: "capitalize",
    width: "100%",
    ..._.get(props, "customStyles.row", {}),
  }),
  rowText: (props) => ({
    width: "100%",
    fontSize: "medium",
    whiteSpace: "normal",
    ..._.get(props, "customStyles.rowText", {}),
  }),
  rowIcon: (props) => ({
    color: "#1F9C00",
    fontSize: "xx-large",
    ..._.get(props, "customStyles.rowIcon", {}),
  }),
  extraText: (props) => ({
    fontSize: "medium",
    ..._.get(props, "customStyles.extraText", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    list: (props) => ({
      gridTemplateColumns: "1fr 1fr",
      ..._.get(props, "customStyles.list.smallscreen", {}),
    }),
    rowText: (props) => ({
      fontSize: "large",
      ..._.get(props, "customStyles.rowText.smallscreen", {}),
    }),
    extraText: (props) => ({
      fontSize: "large",
      ..._.get(props, "customStyles..smallscreen", {}),
    }),
  },
});
const SafetyInfo = ({ data }) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const classes = safetyInfoStyles({
    customStyles: cStyler({
      type,
      brand,
      objName: "actSafetyInfoStyles",
    }),
  });

  return (
    <React.Fragment>
      <div className={classes.extraText}>
        The following health and safety measures are in place, so you can relax
        and enjoy your experience.
      </div>

      <div className={classes.list}>
        {data.map((d, idx) => (
          <div className={classes.row} key={idx}>
            <InlineIcon icon="mdi:tick" className={classes.rowIcon} />
            <div className={classes.rowText}> {d}</div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
};
SafetyInfo.defaultProps = {
  data: [],
};
SafetyInfo.propTypes = {
  data: PropTypes.array.isRequired,
};
export default SafetyInfo;
